package ai.flowstorm.studio.ui

import ai.flowstorm.common.setProperty
import ai.flowstorm.common.ui.EditableEntityComponent
import ai.flowstorm.common.ui.EntityTable
import ai.flowstorm.studio.model.Device
import ai.flowstorm.studio.model.Space
import ai.flowstorm.studio.resources.DeviceResource
import ai.flowstorm.studio.ui.space.DeviceEditor
import ai.flowstorm.studio.ui.space.DeviceForm
import io.kvision.i18n.I18n.tr
import io.kvision.modal.ModalSize
import io.kvision.tabulator.ColumnDefinition
import io.kvision.tabulator.Layout
import io.kvision.tabulator.TabulatorOptions
import io.kvision.utils.obj

class DeviceTable : EntityTable<Device>(
    caption = "Client Device",
    model = DeviceResource,
    tabulatorOptions = TabulatorOptions(
        layout = Layout.FITCOLUMNS,
        columns = listOf(
            ColumnDefinition(tr("Device ID"), Device::deviceId.name),
            ColumnDefinition(tr("Description"), Device::description.name),
            ColumnDefinition(tr("Location"), Device::location.name),
            ColumnDefinition(tr("Last Talk"), Device::lastTalk.name),
            ColumnDefinition(tr("Space"), FIELD_SPACE_NAME)
        )
    ),
    dataExtractor = {
        obj {
            setProperty(this, it::deviceId)
            setProperty(this, it::description)
            setProperty(this, it::location)
            setProperty(this, it::lastTalk)
            setProperty(this, it::description)
            this[FIELD_SPACE_NAME] = it._space?.name

        }
    },
    entityComponentFactory = { DeviceForm(DeviceResource) },
    entityFactory = { Device() },
    entityEditorFactory = { editableEntityComponent: EditableEntityComponent<Device>, saveEnabled: Boolean, deleteEnabled: Boolean ->
        DeviceEditor(editableEntityComponent as DeviceForm, saveEnabled, deleteEnabled)
    },
    saveEnabled = true,
    deleteEnabled = false,
    modalSize = ModalSize.LARGE,
    className = "content-panel"
) {
    companion object {
        const val FIELD_SPACE_NAME = "space_name"
    }
}
